// Status do item do lote (espelha o StatusPagamentoTaxa do backend:
// pagamento_taxa_lote_processo.status_pagamento).
export enum StatusPagamentoTaxa {
  PENDENTE = 0,
  PAGO = 1,
  MANUAL = 2,
  PROCESSANDO = 3,
  ERRO = 4,
  CANCELADO = 5,
  DEBITOS_ADICIONAIS = 6,
}

export const StatusPagamentoTaxaLabel: Record<number, string> = {
  [StatusPagamentoTaxa.PENDENTE]: "Pendente",
  [StatusPagamentoTaxa.PAGO]: "Pago",
  [StatusPagamentoTaxa.MANUAL]: "Pgto manual",
  [StatusPagamentoTaxa.PROCESSANDO]: "Processando",
  [StatusPagamentoTaxa.ERRO]: "Erro",
  [StatusPagamentoTaxa.CANCELADO]: "Cancelado",
  [StatusPagamentoTaxa.DEBITOS_ADICIONAIS]: "Débitos adicionais",
};

export const StatusPagamentoTaxaTituloPopover: Record<number, string> = {
  [StatusPagamentoTaxa.MANUAL]: "Pagamento manual",
  [StatusPagamentoTaxa.CANCELADO]: "Pagamento cancelado",
  [StatusPagamentoTaxa.ERRO]: "Pagamento com erro",
  [StatusPagamentoTaxa.DEBITOS_ADICIONAIS]: "Débitos adicionais",
};

// Options para filtro de Status (dropdown) na tela do lote.
export const statusPagamentoTaxaOptions = Object.entries(
  StatusPagamentoTaxaLabel,
).map(([value, label]) => ({ value: Number(value), label }));
